









import Vue from 'vue'
import Component from 'vue-class-component'

import { DocsEnum } from '@/store/types/docs'
// Components
import DocsCard from '@/components/cards/DocsCard.vue'

@Component({
  components: {
    DocsCard,
  },
})
export default class DocsList extends Vue {
  private get docs() {
    return [
      { date: '2024-06-24', href: DocsEnum.PERSONAL, title: 'Согласие на обработку персональных данных', type: 'personal' },
      { date: '2024-06-24', href: DocsEnum.POLICY, title: 'Политика конфиденциальности персональных данных', type: 'policy' },
      { date: '2024-06-24', href: DocsEnum.USER_TERMS, title: 'Пользовательское соглашение', type: 'terms' },
      { date: '2024-06-24', href: DocsEnum.MENTOR_TERMS, title: 'Условия использования платформы для преподавателей', type: 'terms' },
      { date: '2026-05-20', href: DocsEnum.SERVICES_AGREEMENT, title: 'Договор оказания услуг', type: 'terms' },
    ]
  }
}
